export enum PackageType {
  PACKAGE = 'package',
  PALLET = 'pallet'
}
